import React, { useMemo } from "react";
import sanityConfig from "services/sanity-config";
import Link from "helpers/link";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";

const getGatsbyImage = (img, width) => getGatsbyImageData(
    img,
    width === false ? {} : { width: width || 1200 },
    sanityConfig(),
);

// eslint-disable-next-line id-length
const Image = ({ image, width, className, alt, to, removeSrcset, ...other }) => {
    if (typeof image !== "string" && !image?.asset && !image?._ref) return null;

    const imageMemo = useMemo(() => {
        if (typeof image === "string") {
            return image;
        } 
        
        let gi = getGatsbyImage(image, width);

        if (removeSrcset) {
            gi = {
                ...gi,
                images: {
                    ...gi.images,
                    sources: [],
                },
            };
        }

        return gi;
    }, [image]); 

    const altText = image?.alt ?? alt ?? "Seal Skin Covers";

    const imageComponent = (
        typeof image === "string" ? (
            <img src={imageMemo} alt={altText} className={className} {...other} />
        ) : (
            <GatsbyImage
                image={imageMemo}
                alt={altText}
                className={className}
                {...other}
            />
        )
    );

    return to ? <Link to={to}>{imageComponent}</Link> : (imageComponent);
};

export default Image;
